
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import {SiteServicesRequestType} from "./services.types";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import {IServiceDetailListItem} from "@/entity/services/serviceDetail.types";

@Component
export default class SiteServicesForm extends Form {

    @Validate(required, i18nText("Введите назавание категории"))
    service_id: number | null = null;
    preview_text: string | null = null;
    detail_text: string | null = null;
    procedure_impacts: string[] | null = null;
    procedure_allows: string | null = null;
    image: Record<string, string> | null = null;
    images: Record<string, string>[] | null = null;

    image_file: File | null = null;
    images_file: File[] | null = null;


    getFormData(): SiteServicesRequestType {
        return {
            service_id: this.service_id,
            preview_text: this.preview_text,
            detail_text: this.detail_text,
            procedure_impacts: this.procedure_impacts,
            procedure_allows: this.procedure_allows,
            image: this.image,
            image_file: this.image_file,
            images_file: this.images_file,
            images: this.images,
        }
    }

    setFormData(service: IServiceDetailListItem | null): void {
        if (service !== undefined && service != null) {
            this.service_id = service.service_id;
            this.preview_text = service.preview_text;
            this.detail_text = service.detail_text;
            this.procedure_impacts = service.procedure_impacts;
            this.procedure_allows = service.procedure_allows;
            this.image = service.image;
            this.images = service.images;
        }
    }
}
